module.exports = __webpack_public_path__ + "assets/img/tx102s_4.4d30ad46.jpg";